var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 0.666672H1.99967C1.08301 0.666672 0.341341 1.41667 0.341341 2.33334L0.333008 15.6667C0.333008 16.5833 1.07467 17.3333 1.99134 17.3333H11.9997C12.9163 17.3333 13.6663 16.5833 13.6663 15.6667V5.66667L8.66634 0.666672ZM11.9997 15.6667H1.99967V2.33334H7.83301V6.50001H11.9997V15.6667ZM4.34967 9.87501L3.16634 11.05L6.11634 14L10.833 9.28334L9.65801 8.10834L6.12467 11.6417L4.34967 9.87501Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.18c6082d.svg";
export { ForwardRef as ReactComponent };